import Link from 'next/link'
import type { MatchedHeaderCategory } from '../hooks/useHeaderCategories'

type Props = {
  isOpen: boolean
  coords: { left: number; top: number } | null
  items: MatchedHeaderCategory[]
  language: string
  onClose: () => void
  getHref: (category: any, locale: AppLocale) => string
}

export function CategoryDropdown({
  isOpen,
  coords,
  items,
  language,
  onClose,
  getHref,
}: Props) {
  if (!isOpen || !coords) return null
  return (
    <div
      data-header-dropdown
      className="absolute z-50 w-56 bg-white border border-gray-200 rounded-md shadow-lg"
      style={{ left: coords.left, top: coords.top }}
    >
      <ul className="py-1">
        {items.map((item) => (
          <li key={item._id} className="min-w-0">
            <Link
              href={getHref(item.category, language as AppLocale)}
              className="block px-4 py-2 text-sm hover:bg-gray-100 truncate"
              onClick={onClose}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
